<div class="complementary-report">
    <form [formGroup]="formGroup" class="form-container">
        <div class="action-container">
            <div class="action-item action-item-container">
                <div class="icon-wrapper">
                    <div class="toc-toggle action-item">
                        <ham-toggle [formControlValue]="formGroup.controls['showInToc']"></ham-toggle>
                        <span>{{ 'aumico_annual_report_complementary_reports_show_in_toc_toggle' | i18next }}</span>
                    </div>
                    <div
                        class="toc-toggle action-item"
                        *ngIf="!(isUploading || updatedComplementaryReports[this.reportIndex]?.fileId)"
                    >
                        <ham-toggle [formControlValue]="formGroup.controls['showTitleInReport']"></ham-toggle>
                        <span>{{
                            'aumico_annual_report_complementary_reports_show_title_in_report_toggle' | i18next
                        }}</span>
                    </div>
                    <div
                        class="toc-toggle action-item"
                        *ngIf="isUploading || updatedComplementaryReports[this.reportIndex]?.fileId"
                    >
                        <ham-toggle [formControlValue]="formGroup.controls['showPageNumbers']"></ham-toggle>
                        <span>{{
                            'aumico_annual_report_complementary_reports_show_page_numbers_toggle' | i18next
                        }}</span>
                    </div>
                </div>
                <div class="action-item">
                    <ham-button
                        icon="assets/hamIcons/download-icon.svg"
                        type="submit"
                        size="xs"
                        outline="true"
                        (buttonClick)="onPrintComplementaryReportClicked()"
                    >
                        {{ 'aumico_reports_annualreport_navigation_print_using_pdf_tron' | i18next }}
                    </ham-button>

                    <ham-button
                        icon="assets/hamIcons/trash-outline.svg"
                        type="submit"
                        size="xs"
                        outline="true"
                        (buttonClick)="onDeleteReportClicked()"
                    >
                        {{ 'aumico_annual_report_complementary_reports_delete_icon_text' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div style="width: 100%">
                <ng-container
                    *ngIf="!isUploading && !updatedComplementaryReports[this.reportIndex]?.fileId; else fileInfo"
                >
                    <ham-tiptap-toolbar
                        [editor]="tiptapEditor"
                        (imageSelected)="onTiptapImageSelected($event)"
                        headerOffsetSelector="inner-page-tab-navigation"
                        [headerOffsetPx]="104"
                    >
                        <div #tiptapHost class="tiptap-editor"></div>
                    </ham-tiptap-toolbar>
                </ng-container>
            </div>
        </div>
        <ng-template #fileInfo>
            <div class="file-info-wrapper">
                <span
                    class="extension-icon"
                    hamIconShapes
                    icon="assets/hamIcons/pdf.svg"
                    [size]="'20px'"
                    [variant]="'transparent'"
                ></span>
                <div class="file-info-text">
                    <ng-container *ngIf="isUploading">Uploading file…</ng-container>
                    <ng-container *ngIf="!isUploading">
                        {{
                            decodeFileName(complementaryReport?.fileName) ||
                                decodeFileName(updatedComplementaryReports[this.reportIndex]?.fileName)
                        }}</ng-container
                    >
                </div>
                <ham-button
                    type="submit"
                    size="xs"
                    outline="true"
                    icon="assets/hamIcons/eye-outline.svg"
                    (buttonClick)="onPreviewClick()"
                    >{{ 'aumico_annual_report_complementary_reports_preview_button' | i18next }}
                </ham-button>
            </div>
        </ng-template>
    </form>
</div>
<ham-modal
    *ngIf="isPreviewModalOpen"
    [title]="
        decodeFileName(complementaryReport?.fileName) ||
        decodeFileName(updatedComplementaryReports[this.reportIndex]?.fileName)
    "
    [size]="'default'"
    (cancel)="onClosePreviewModal()"
    hideFooter="true"
>
    <div class="flyout-preview-content">
        <ng-container *ngIf="previewUrl; else noPreview">
            <img [src]="previewUrl" alt="Document Preview" class="preview-image" />
            <div class="flyout-buttons">
                <ham-button size="sm" (click)="downloadDocument()">{{
                    'aumico_app_cpmm_documents_download' | i18next
                }}</ham-button>
                <ham-button size="sm" (click)="openDocument()">{{
                    'aumico_app_cpmm_documents_open' | i18next
                }}</ham-button>
            </div>
        </ng-container>
        <ng-template #noPreview>
            <div class="no-preview-message">
                <span>{{ getPreviewStatusText(previewStatus) }}</span>
            </div>
        </ng-template>
    </div>
</ham-modal>
